"use strict";
exports.__esModule = true;
exports.InAppPaymentType = exports.feeTransactionCategories = exports.TransactionCategory = exports.TransactionStatus = exports.TransactionType = void 0;
var TransactionType;
(function (TransactionType) {
    TransactionType["RENT_PAYMENT"] = "RENT_PAYMENT";
    TransactionType["DOWN_PAYMENT"] = "DOWN_PAYMENT";
    TransactionType["REPAYMENT"] = "REPAYMENT";
    TransactionType["REFUND"] = "REFUND";
    TransactionType["MEMBERSHIP_FEE"] = "MEMBERSHIP_FEE";
})(TransactionType = exports.TransactionType || (exports.TransactionType = {}));
var TransactionStatus;
(function (TransactionStatus) {
    TransactionStatus["PAID"] = "PAID";
    TransactionStatus["SCHEDULED"] = "SCHEDULED";
    TransactionStatus["REFUNDED"] = "REFUNDED";
    TransactionStatus["FUNDED"] = "FUNDED";
    TransactionStatus["FAILED"] = "FAILED";
    TransactionStatus["UNPAID"] = "UNPAID";
    TransactionStatus["AUTHORIZED"] = "AUTHORIZED";
    TransactionStatus["OUTSTANDING_BALANCE"] = "OUTSTANDING_BALANCE";
})(TransactionStatus = exports.TransactionStatus || (exports.TransactionStatus = {}));
(function (TransactionType) {
    TransactionType["PAYMENT"] = "PAYMENT";
    TransactionType["CHARGE"] = "CHARGE";
})(TransactionType = exports.TransactionType || (exports.TransactionType = {}));
var TransactionCategory;
(function (TransactionCategory) {
    TransactionCategory["FLEX_CREDIT_LINE"] = "FLEX_CREDIT_LINE";
    TransactionCategory["FIRST_PAYMENT"] = "FIRST_PAYMENT";
    TransactionCategory["REPAYMENT"] = "REPAYMENT";
    TransactionCategory["BILL_PAYMENT_FEE"] = "BILL_PAYMENT_FEE";
    TransactionCategory["MEMBERSHIP_FEE"] = "MEMBERSHIP_FEE";
    TransactionCategory["PAYMENT"] = "PAYMENT";
    TransactionCategory["REFUND"] = "REFUND";
    TransactionCategory["APPLIED"] = "APPLIED";
    TransactionCategory["BILL_PAYMENT_PLUS_PROCESSING_FEE"] = "BILL_PAYMENT_PLUS_PROCESSING_FEE";
    TransactionCategory["BILL_PAYMENT_ABOVE_ESTIMATE"] = "BILL_PAYMENT_ABOVE_ESTIMATE";
    TransactionCategory["FIRST_PAYMENT_ESTIMATE"] = "FIRST_PAYMENT_ESTIMATE";
    TransactionCategory["DEPOSIT"] = "DEPOSIT";
    TransactionCategory["PROPERTY_PASSTHROUGH_FEE"] = "PROPERTY_PASSTHROUGH_FEE";
})(TransactionCategory = exports.TransactionCategory || (exports.TransactionCategory = {}));
exports.feeTransactionCategories = [
    TransactionCategory.BILL_PAYMENT_PLUS_PROCESSING_FEE,
    TransactionCategory.BILL_PAYMENT_FEE,
];
var InAppPaymentType;
(function (InAppPaymentType) {
    InAppPaymentType["REPAYMENT"] = "repayment";
    InAppPaymentType["OUTSTANDING_BALANCE"] = "outstandingBalance";
})(InAppPaymentType = exports.InAppPaymentType || (exports.InAppPaymentType = {}));
